import { AuthStorage, PluggableStorage } from '@frontend/auth-helpers';
import { knownMobileAppClientIDs } from '../new-auth/constants';

/**
 * Hydra session storage to persist data across the auth flow. Uses sessionStorage.
 */
export const hydraSessionStore = PluggableStorage.create('hydra', sessionStorage);

/**
 * Are we signing into a Weave mobile client?
 * NOTE that we will only know this after the login flow has begun
 */
type OauthClientInfo = { clientId: string; clientName: string };
export function isWeaveMobileClient(): boolean {
  const oauthClientInfo = hydraSessionStore.getItem<OauthClientInfo, Record<string, any>>(
    AuthStorage.oauth_client_info,
    {}
  );
  return knownMobileAppClientIDs.has(oauthClientInfo?.clientId);
}
